var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { QuestionImageAdornerViewModel } from "survey-creator-core";
import * as React from "react";
import { attachKey2click, LoadingIndicatorComponent, ReactElementFactory, ReactQuestionFactory, SvgIcon } from "survey-react-ui";
import { QuestionAdornerComponent } from "./Question";
var QuestionImageAdornerComponent = /** @class */ (function (_super) {
    __extends(QuestionImageAdornerComponent, _super);
    function QuestionImageAdornerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionImageAdornerComponent.prototype.createQuestionViewModel = function (props) {
        return new QuestionImageAdornerViewModel(props.componentData, props.question, null);
    };
    Object.defineProperty(QuestionImageAdornerComponent.prototype, "imageModel", {
        get: function () {
            return this.model;
        },
        enumerable: false,
        configurable: true
    });
    QuestionImageAdornerComponent.prototype.renderHeader = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("input", { type: "file", "aria-hidden": "true", tabIndex: -1, accept: this.imageModel.acceptedTypes, className: "svc-choose-file-input", style: {
                    position: "absolute",
                    opacity: 0,
                    width: "1px",
                    height: "1px",
                    overflow: "hidden"
                } }),
            _super.prototype.renderHeader.call(this)));
    };
    QuestionImageAdornerComponent.prototype.renderLoadingPlaceholder = function () {
        return (React.createElement("div", { className: "svc-image-question__loading-placeholder" },
            React.createElement("div", { className: "svc-image-question__loading" },
                React.createElement(LoadingIndicatorComponent, null))));
    };
    QuestionImageAdornerComponent.prototype.renderChooseButton = function () {
        var _this = this;
        return (React.createElement("div", { className: "svc-image-question-controls" }, this.model.allowEdit ? attachKey2click(React.createElement("span", { className: "svc-context-button", onClick: function () { return _this.imageModel.chooseFile(_this.imageModel); } },
            React.createElement(SvgIcon, { size: "auto", iconName: "icon-choosefile" }))) : null));
    };
    QuestionImageAdornerComponent.prototype.renderElementPlaceholder = function () {
        return this.imageModel.isUploading ? this.renderLoadingPlaceholder() : this.renderChooseButton();
    };
    QuestionImageAdornerComponent.prototype.getStateElements = function () {
        return [this.model, this.imageModel.filePresentationModel];
    };
    QuestionImageAdornerComponent.prototype.renderElementContent = function () {
        if (this.imageModel.isEmptyImageLink) {
            var fileQuestion = ReactQuestionFactory.Instance.createQuestion("file", {
                creator: this.imageModel.question.survey,
                isDisplayMode: false,
                question: this.imageModel.filePresentationModel
            });
            return (React.createElement(React.Fragment, null, fileQuestion));
        }
        else {
            return (React.createElement(React.Fragment, null,
                this.props.element,
                this.renderElementPlaceholder()));
        }
    };
    return QuestionImageAdornerComponent;
}(QuestionAdornerComponent));
export { QuestionImageAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-image-question", function (props) {
    return React.createElement(QuestionImageAdornerComponent, props);
});
